import { Component, Input } from '@angular/core';

@Component({
  selector: 'share-buttons-custom',
  templateUrl: './shareButtons.component.html',
})
export class ShareButtonsComponent {
  @Input('metadata') metadata: string;
}
